import { FormattedMessage } from "react-intl";
import { PAYMENT_METHODS } from "app/constants";
import PropTypes from "prop-types";
import InsurancesFieldset from "@brand/Payment/InsurancesFieldset";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { useEffect, useRef } from "react";
import useOnScreen from "app/pages/.shared/useOnScreen";
import { useField, useFormikContext } from "formik";
import isEmpty from "lodash/isEmpty";
import FormErrorMessages from "app/pages/.shared/form/FormErrorMessages/FormErrorMessages";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

function PaymentInsurancesSection({
	payment = {},
	shop,
	assuranceMultirisquesSansMotifDocumentName,
	assuranceAnnulationSansMotifDocumentName,
	resolution,
	total,
	onInsuranceSelect = () => {},
	refInsuranceErrorMessage,
}) {
	const { track } = useAnalytics();
	const ref = useRef();
	const isElementOnScreen = useOnScreen({ ref, triggerOnce: false });
	const [field] = useField("payment");
	const { setFieldValue, setFieldError, errors, isSubmitting, submitCount } = useFormikContext();

	useEffect(() => {
		if (isElementOnScreen) {
			track("insurance_view");
		}
	}, [isElementOnScreen]);

	const hasAdyenFlow = payment.paymentTypes?.some(
		type => type.paymentType === PAYMENT_METHODS.ADYEN_FLOW
	);

	const onInsuranceSelection = insurance => {
		const totalPlusInsurance = total + insurance.price;
		const data = { insurance };

		if (
			totalPlusInsurance > payment.paymentSwissbilling?.maxAmount &&
			field?.type === PAYMENT_METHODS.SWISS_BILLING
		) {
			if (hasAdyenFlow) {
				data.paymentType = PAYMENT_METHODS.ADYEN_FLOW;
				setFieldValue("payment.type", PAYMENT_METHODS.ADYEN_FLOW);
			} else {
				data.paymentType = PAYMENT_METHODS.CARD;
				setFieldValue("payment.type", PAYMENT_METHODS.CARD);
			}
		}

		onInsuranceSelect(data, insurance);
		if (!isEmpty(errors?.insurance)) {
			setFieldError("insurance");
		}
	};

	return (
		<>
			<Typography
				variant={TYPOGRAPHY_VARIANTS.XL3}
				variantMD={TYPOGRAPHY_VARIANTS.XL4}
				isBold
				className="payment__title"
				component="h2"
				innerRef={ref}
			>
				<FormattedMessage id="payment.insurance.title" />
			</Typography>
			<div className="payment__content" ref={refInsuranceErrorMessage}>
				<FormErrorMessages
					errors={errors}
					message={<FormattedMessage id="error.payment.insurance.required" />}
					fieldsFilter={["insurance"]}
					isSubmitting={isSubmitting}
					submitCount={submitCount}
					disableErrorsDetails={true}
				/>

				<InsurancesFieldset
					intro={payment.insurances.intro}
					logo={payment.insurances.logo}
					onChange={onInsuranceSelection}
					insurances={payment.insurances.insurancesItem}
					assuranceMultirisquesSansMotifDocumentName={
						assuranceMultirisquesSansMotifDocumentName
					}
					assuranceAnnulationSansMotifDocumentName={
						assuranceAnnulationSansMotifDocumentName
					}
					resolution={resolution}
					shop={shop}
				/>
			</div>
		</>
	);
}

PaymentInsurancesSection.propTypes = {
	payment: PropTypes.object,
	shop: PropTypes.string,
	assuranceMultirisquesSansMotifDocumentName: PropTypes.string,
	assuranceAnnulationSansMotifDocumentName: PropTypes.string,
	resolution: PropTypes.string,
	total: PropTypes.string,
	refInsuranceErrorMessage: PropTypes.string,
	onInsuranceSelect: PropTypes.func,
};
export default PaymentInsurancesSection;
